var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.roleInOrganizationError || _vm.roleInVesselError)?_c('div',{staticClass:"fill-height"},[_c('GenericError')],1):(_vm.roleInOrganizationLoading || _vm.roleInVesselLoading)?_c('div',{staticClass:"content-spinner"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"50","color":"primary"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }